import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import Icon from 'vibo-ui/Icon';

import { EmptyStateProps, DefaultEmptyStateProps } from './interfaces';

import useStyles from './style';

const EmptyState: FC<PropsWithChildren<EmptyStateProps & DefaultEmptyStateProps>> = ({
  icon,
  className,
  grayText,
  children,
  size = 'sm',
}) => {
  const classes = useStyles();

  return (
    <div
      className={classNames('emptyState', classes.emptyState, size, className, {
        grayText,
      })}
    >
      <Icon className="stateIcon" icon={icon} disableAutoFontSize />
      <div className="description">{children}</div>
    </div>
  );
};

export default EmptyState;
